import { render, staticRenderFns } from "./RevisionsView.vue?vue&type=template&id=f3bf441c&scoped=true&"
import script from "./RevisionsView.vue?vue&type=script&lang=js&"
export * from "./RevisionsView.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsView.vue?vue&type=style&index=0&id=f3bf441c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf441c",
  null
  
)

export default component.exports